<template>
  <div id="news" class="reader-wrapper" :class="{ 'article-open': showNews }">
    <div class="reader-left col col-12 md-col-6 lg-col-5">
      <div
        class="sticky bg-light item border-bottom flex justify-content col-12"
      >
        <a
          class="hover-red caps fs-s p1 flex-auto center"
          href="https://twitter.com/forensicarchi"
          target="_blank"
          >Twitter</a
        >
        <a
          class="hover-red caps fs-s p1 flex-auto center border-left border-black"
          href="https://www.facebook.com/forensic.architecture/?ref=br_rs"
          target="_blank"
          >Facebook</a
        >
        <a
          class="hover-red caps fs-s p1 flex-auto center border-left border-black"
          href="https://www.instagram.com/forensicarchitecture/?hl=en"
          target="_blank"
          >Instagram</a
        >
        <a
          class="hover-red caps fs-s p1 flex-auto center border-left border-black"
          href="https://forensicarchitecture.substack.com/"
          target="_blank"
          >Newsletter</a
        >
      </div>
      <router-link
        v-for="(item, index) in news"
        class="block reader-block item col-12 p2 border-bottom border-right pointer"
        :key="item.id"
        :class="{ active: currentNewsItem === index }"
        @click="updateNewsItem(index)"
        :ref="`feed-item-${index}`"
        :to="{ name: 'News', params: { slug: item.slug } }"
        replace
      >
        <div class="mr3">
          <h2 class="caps" v-html="preventWidows(item.title)"></h2>
          <h3 class="mb0 fs-s tabular" v-html="formatDate(item.date)"></h3>
        </div>
      </router-link>
    </div>
    <div
      v-if="showNews"
      @scroll="lazyContainer.update()"
      class="reader-right col col-12 md-col-6 lg-col-7 relative"
    >
      <div
        class="sticky bg-light item border-bottom flex justify-content col-12 caps fs-s"
      >
        <span
          class="noselect p1 flex-auto hover-red pointer center border-right border-black"
          @click="previousArticle()"
          >Previous Article</span
        >
        <span
          class="noselect p1 flex-auto hover-red pointer center"
          @click="nextArticle()"
          >Next Article</span
        >
      </div>
      <div v-if="news" class="p2 max-reader-width mx-auto mt3">
        <h2 class="caps center" v-html="currentTitle"></h2>
        <h3 class="caps center tabular" v-html="currentDate"></h3>
        <div
          class="mt3 sans fs-reader lazy-container"
          v-html="currentContent"
        ></div>
      </div>
    </div>

    <div
      v-if="showNews"
      @scroll="lazyContainer.update()"
      class="reader-mobile col col-12 md-col-6 lg-col-7 relative md-hide lg-hide"
    >
      <div
        class="sticky bg-light item border-bottom flex justify-content col-12 caps fs-s"
      >
        <span
          class="noselect p1 flex-auto hover-red pointer center border-right border-black"
          @click="closeArticle()"
          >Close</span
        >
        <span
          class="noselect p1 flex-auto hover-red pointer center border-right border-black"
          @click="previousArticle()"
          >Previous Article</span
        >
        <span
          class="noselect p1 flex-auto hover-red pointer center"
          @click="nextArticle()"
          >Next Article</span
        >
      </div>
      <div v-if="news" class="p2 max-reader-width mx-auto mt3">
        <h2 class="caps center" v-html="currentTitle"></h2>
        <h3 class="caps center tabular" v-html="currentDate"></h3>
        <div
          class="mt3 sans fs-reader lazy-container"
          v-html="currentContent"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate } from "@/utils";
import VueScrollTo from "vue-scrollto";

export default {
  name: "News",

  data() {
    return {
      currentNewsItem: false,
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img",
      }),
    };
  },

  metaInfo: {
    title: "News",
  },

  computed: {
    ...mapState(["news"]),
    currentTitle() {
      return this.preventWidows(this.news[this.currentNewsItem].title);
    },
    currentDate() {
      return this.formatDate(this.news[this.currentNewsItem].date);
    },
    currentContent() {
      return this.news[this.currentNewsItem].content;
    },
    showNews() {
      return this.currentNewsItem || this.currentNewsItem === 0;
    },
  },

  methods: {
    formatDate,
    newsNav() {
      event.stopPropagation();
      if (event.key == "ArrowLeft" || event.key == "ArrowUp") {
        this.previousArticle();
      } else if (event.key == "ArrowRight" || event.key == "ArrowDown") {
        this.nextArticle();
      }
    },
    getNewsItemIndexFromSlug(slug) {
      return this.news.findIndex((x) => {
        return x.slug === slug;
      });
    },
    closeArticle() {
      this.currentNewsItem = false;
      this.$router.replace({ name: "News" });
    },
    nextArticle() {
      if (this.currentNewsItem === this.news.length - 1) {
        this.updateNewsItem(0);
      } else {
        this.updateNewsItem(this.currentNewsItem + 1);
      }
    },
    previousArticle() {
      if (this.currentNewsItem === 0) {
        this.updateNewsItem(this.news.length - 1);
      } else {
        this.updateNewsItem(this.currentNewsItem - 1);
      }
    },
    scrollSideBar() {
      let el = this.$refs[`feed-item-${this.currentNewsItem}`][0].$el;
      VueScrollTo.scrollTo(el, {
        container: ".reader-left",
        offset: -32,
        duration: 250,
        onDone: () => {
          this.updateSlugFromNewsItem();
        },
      });
    },
    updateNewsItem(index) {
      this.currentNewsItem = index;
      this.$nextTick(function () {
        this.lazyContainer.update();
        this.scrollSideBar();
      });
    },
    updateNewsItemFromSlug() {
      if (this.$route.params.slug !== undefined) {
        this.updateNewsItem(
          this.getNewsItemIndexFromSlug(this.$route.params.slug)
        );
      } else {
        // TODO: Custom media var for breakpoints
        // TODO: Move to the new media query hover option
        // Though tbh it's more dependent on width than touch
        // Connect to 831px breakpoint at least
        let isMobile = window.matchMedia("(max-width: 52em)").matches;
        if (!isMobile) {
          this.updateNewsItem(0);
        }
      }
    },
    updateSlugFromNewsItem() {
      if (this.currentNewsItem >= 0) {
        this.$router.replace({
          name: "News",
          params: { slug: this.news[this.currentNewsItem].slug },
        });
      }
    },
  },
  mounted: function () {
    this.updateNewsItemFromSlug();
    document.addEventListener("keyup", this.newsNav);
  },
  destroyed() {
    document.removeEventListener("keyup", this.newsNav);
  },
  watch: {
    $route() {
      this.updateNewsItemFromSlug();
    },
  },
};
</script>

<style lang="css" scoped>
>>> .cursor-zoom-in {
  cursor: default;
}
</style>
